export class BaseBackoffice {
    constructor() {
        this.sapEquipmentNr = null;
        this.isBackoffice = true;
    }
}
